export const APP_ROUTES = {
  home: "/",
  login: "/login",
  magicLink: "/magic-link",
  noAccess: "/no-access",
  dashboard: "/dashboard",
  report: "/reports/:id/:viewname",
  overview: "/overview",
  settings: {
    notifications: "/settings/basic-notifications",
    scheduledNotifications: "/settings/scheduled-notifications",
    reportingStructure: "/settings/reporting-structure",
    reportingPeriod: "/settings/reporting-period",
    manageProjectsDataModel: "/settings/manage-projects-data-model",
    manageItemsDataModel: "/settings/manage-items-data-model",
    manageReportingData: "/settings/manage-reporting-data",
    manageMainEntities: "/settings/manage-main-entities",
    manageUsers: "/settings/manage-users",
    manageSubentities: "/settings/manage-subentities",
    manageReportingCycle: "/settings/manage-reporting-cycle",
    manageAccess: "/settings/manage-access",
    reportingUseCase: "/settings/reporting-use-case",
  },
  editReport: "/reports/:id/:viewname/edit",
  editReportByDimension: "/reports/:id/:viewname/dimension/:dimension/edit",
  editManagementSummary: "/dashboard/edit-management-summary",
  projectDialog: "/overview/project/:id/:isFromOverview",
  trackingItemDialog: "/reports/:id/:viewname/tracking-item/:tracking-item-id",
  logs: "/logs",
} as const;

export const RESOURCE_LOCK_POLLING_INTERVAL = 10_000; // 10 seconds
